"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.documentPayloadsSchema = void 0;
var document_payload_schema_1 = require("./document-payload-schema");
exports.documentPayloadsSchema = {
    type: 'array',
    items: document_payload_schema_1.documentPayloadSchema,
    properties: {},
};
